import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		main: {
			// ?safe&mock-data&utm_campaign=US_All_GDN_Core_tCPA-click_FastingGS_Topics_Weight-Loss_Web_AllDev_DT_0077_190625_s2s&utm_source=google&country=US&area=main&exp=web_welcome_fasting_for_weight_loss~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_welcome_fasting_for_weight_loss'),
			},
		},
	},
]

export default config
